export default __webpack_public_path__ + "static/media/git.49e8db82.png";